module.exports = __webpack_public_path__ + "img/cost-icon__area_verde.14c991ac.svg";